jQuery(document).ready(function($) {
    if ($('section.homepage-signpost-slider').length) {
        $('.homepage-signpost-slider .content').on('click', function(e) {
            e.stopPropagation();
        });

        $('.homepage-signpost-slider .sp-slide').on('click', function() {
            let url = $(this).data('url');
            let target = $(this).data('target');
            if (url) {
                let a = document.createElement('a');
                a.href = url;
                if (target) a.target = target;
                a.click();
            }
        });
    }
});
